module.exports = __webpack_public_path__ + "img/DE03817.33be171e.png";